var _rect, _path, _path2, _path3, _g, _path4, _g2, _path5, _g3, _path6, _g4, _path7, _g5, _path8, _g6, _path9, _g7, _path10, _g8, _path11, _g9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoRegGuideV1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 24,
    viewBox: "0 0 152 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21.6,
    height: 21.6,
    rx: 1.92,
    fill: "#133F7A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6395 18.8401H19.14L11.5271 2.64014H8.935V2.7645C9.71187 3.25197 9.76756 3.92644 9.29937 5.06115L2.94 18.8401H4.69669L6.81962 13.9872H14.4863L16.6395 18.8401ZM7.35833 12.6882L10.5945 5.30593L13.8804 12.6882H7.35833Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.08 0.96C22.08 1.48937 22.5106 1.92 23.04 1.92C23.5749 1.92 24 1.48937 24 0.96C24 0.430629 23.5749 0 23.04 0C22.5106 0 22.08 0.430629 22.08 0.96ZM22.2994 0.96C22.2994 0.5376 22.6313 0.192 23.04 0.192C23.4514 0.192 23.7778 0.534857 23.7778 0.96C23.7778 1.38514 23.4514 1.728 23.04 1.728C22.6313 1.728 22.2994 1.3824 22.2994 0.96ZM22.6889 1.43177H22.9084V1.05874H22.9714C23.1717 1.05874 23.1799 1.13829 23.1826 1.21234C23.1881 1.36046 23.1799 1.38514 23.2183 1.43177H23.4432C23.4048 1.37966 23.413 1.35223 23.4048 1.20411C23.3993 1.1136 23.3911 1.00114 23.2677 0.976457V0.970971C23.4158 0.924343 23.4295 0.811886 23.4295 0.751543C23.4295 0.6912 23.4295 0.471771 23.1086 0.471771H22.6889V1.43177ZM22.9084 0.641829H23.0537C23.0866 0.641829 23.2073 0.644571 23.2073 0.765257C23.2073 0.822857 23.1799 0.888686 23.0729 0.888686H22.9084V0.641829Z",
    fill: "#133F7A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_48_6270",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 131,
    y: 2,
    width: 11,
    height: 16
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M140.748 2.87598V4.02801H133.506V9.06784H139.948V10.1914H133.506V16.0134H141.2V17.276H131.6V2.87598H140.748Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_48_6270)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M128.6 -0.124023H144.2V20.276H128.6V-0.124023Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_48_6270",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 101,
    y: 2,
    width: 14,
    height: 16
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M103.691 2.87598L108.609 15.059L113.408 2.87598H114.8L108.93 17.276H107.539L101.6 2.87598H103.691Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_48_6270)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.5996 -0.124023H117.8V20.276H98.5996V-0.124023Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_48_6270",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 72,
    y: 2,
    width: 13,
    height: 16
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.863 2.59277C82.0021 2.59277 83.6399 2.91265 84.581 3.26271V4.74783L84.5419 4.77965C83.5902 3.93836 81.9589 3.63236 80.5786 3.63236C77.3233 3.63236 74.7313 6.10892 74.7313 10.0053C74.7313 14.6475 77.5572 16.4656 80.8556 16.4941C82.1911 16.5039 83.9422 16.2575 84.9461 15.1959L84.9779 15.2293V17.0539C83.7532 17.4072 82.0583 17.732 80.7668 17.7296C76.6747 17.7116 72.713 15.3403 72.713 10.2216C72.713 6.37412 75.7523 2.59277 80.863 2.59277Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_48_6270)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.713 -0.407227H87.9779V20.7296H69.713V-0.407227Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_48_6270",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 87,
    y: 2,
    width: 13,
    height: 16
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7376 2.93042V12.2475C89.7376 14.3577 90.4156 16.6253 93.6505 16.6253C96.6955 16.6253 98.0091 14.813 98.0091 12.1276V2.93042H99.3381V12.0859C99.3381 15.2308 97.2732 17.7269 93.6578 17.7269C90.0448 17.7269 87.8252 15.536 87.8252 12.3462V2.93042H89.7376Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_48_6270)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.8252 -0.0695801H102.338V20.7269H84.8252V-0.0695801Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_48_6270",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 58,
    y: 2,
    width: 15,
    height: 16
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8247 2.82568L72.3964 17.388H70.2378L68.3792 13.0249H61.7611L59.9293 17.388H58.4121L63.9017 5.00114C64.3066 3.98196 64.2578 3.37485 63.5871 2.93748V2.82568H65.8247ZM65.0441 5.2084L62.2345 11.9021H67.8976L65.0441 5.2084Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_48_6270)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.4121 -0.174316H75.3964V20.388H55.4121V-0.174316Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_48_6270",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 116,
    y: 2,
    width: 13,
    height: 16
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M118.763 2.93042V12.2475C118.763 14.3577 119.442 16.6253 122.676 16.6253C125.721 16.6253 127.035 14.813 127.035 12.1276V2.93042H128.365V12.0859C128.365 15.2308 126.299 17.7269 122.684 17.7269C119.072 17.7269 116.853 15.536 116.853 12.3462V2.93042H118.763Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_48_6270)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.853 -0.0695801H131.365V20.7269H113.853V-0.0695801Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_48_6270",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 32,
    y: 2,
    width: 15,
    height: 16
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6702 2.86279L39.0981 14.6418H39.1771L43.684 2.86279H46.3346V17.2383H44.5477V8.39854C44.5477 7.41526 44.5941 6.16678 44.6854 4.65147H44.6063L39.8151 17.2383H38.3329L33.5995 4.6327H33.5213C33.6199 5.68126 33.668 6.97625 33.668 8.51686V17.2383H32V2.86279H34.6702Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_48_6270)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 -0.137207H49.3346V20.2383H29V-0.137207Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_48_6270",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 48,
    y: 6,
    width: 11,
    height: 17
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2031 6.44141L52.5311 12.5867C53.0216 13.9249 53.3223 14.9041 53.4339 15.5276H53.513C53.5716 15.2852 53.7053 14.8307 53.9155 14.1657C54.1249 13.4998 54.3009 12.9678 54.4451 12.5679L56.6354 6.44141H58.5397L53.8951 18.7328C53.4437 19.9258 52.9075 20.781 52.285 21.2991C51.6633 21.8173 50.8941 22.076 49.9774 22.076C49.486 22.076 48.9988 22.0205 48.5147 21.9087V20.5027C48.8415 20.5811 49.2351 20.621 49.693 20.621C50.2561 20.621 50.7344 20.4652 51.1263 20.1543C51.5191 19.8426 51.8401 19.3619 52.0886 18.7132L52.6484 17.2771L48.3086 6.44141H50.2031Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_48_6270)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.3086 3.44141H61.5397V25.076H45.3086V3.44141Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_48_6270",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 142,
    y: 1,
    width: 10,
    height: 10
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M147.384 1.92383C148.643 1.92383 149.713 2.36495 150.595 3.2486C151.475 4.13225 151.915 5.19623 151.915 6.44332C151.915 7.6918 151.475 8.75024 150.595 9.62001C149.713 10.487 148.643 10.924 147.384 10.924C146.124 10.924 145.056 10.487 144.173 9.62001C143.29 8.75024 142.85 7.6918 142.85 6.44332C142.85 5.19623 143.29 4.13225 144.173 3.2486C145.056 2.36495 146.124 1.92383 147.384 1.92383ZM147.384 2.6202C146.325 2.6202 145.423 2.99613 144.679 3.7466C143.936 4.49569 143.565 5.39599 143.565 6.44332C143.565 7.49204 143.941 8.39095 144.689 9.14004C145.439 9.89051 146.337 10.2678 147.384 10.2678C148.43 10.2678 149.329 9.89051 150.077 9.14004C150.828 8.39095 151.199 7.49204 151.199 6.44332C151.199 5.39599 150.829 4.49569 150.088 3.7466C149.344 2.99613 148.444 2.6202 147.384 2.6202ZM147.402 3.87562C147.933 3.87562 148.38 3.9963 148.746 4.24322C149.109 4.48876 149.292 4.8633 149.292 5.36824C149.292 6.11178 148.901 6.56956 148.12 6.74296L149.491 8.9708H148.377L147.185 6.84145H146.53V8.9708H145.615V3.87562H147.402ZM147.363 4.65106H146.53V6.10484H147.264C148.006 6.10484 148.377 5.85238 148.377 5.34882C148.377 4.88272 148.04 4.65106 147.363 4.65106Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_48_6270)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.85 -1.07617H154.915V13.924H139.85V-1.07617Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRegGuideV1);
export default __webpack_public_path__ + "static/media/logo-reg-guide-v1.1ca2548b176efa0451a20bdd43304a99.svg";
export { ForwardRef as ReactComponent };